import { useState, useEffect } from 'react';
import addSeconds from 'date-fns/addSeconds';
import differenceInSeconds from 'date-fns/differenceInSeconds';

function useTimer() {
  const [limitTime, setLimitTime] = useState<Date | null>();
  const [secondsAmount, setSecondsAmount] = useState(120);
  const [isPause, setIsPause] = useState(true);

  const minutes = Math.floor(secondsAmount / 60);
  const seconds = secondsAmount % 60;
  const formattedTime = `${minutes}:${String(seconds).padStart(2, '0')}`;

  let interval: NodeJS.Timer | number = 0;

  useEffect(() => {
    if (!limitTime) {
      if (secondsAmount > 0) {
        setLimitTime(addSeconds(new Date(), secondsAmount));
      }
    }
  }, [secondsAmount, limitTime]);

  useEffect(() => {
    if (limitTime && !isPause) {
      const time = differenceInSeconds(limitTime, new Date());

      if (time >= 0) {
        interval = setInterval(() => {
          setSecondsAmount(time);
        }, 1000);
      }
    }

    return () => clearInterval(interval);
  }, [secondsAmount, limitTime]);

  const start = (timeInSeconds: number) => {
    setIsPause(false);
    clearInterval(interval);
    setLimitTime(null);
    setSecondsAmount(timeInSeconds);
  };

  const pause = () => {
    setIsPause(true);
  };

  return { start, formattedTime, secondsAmount, pause };
}

export default useTimer;
